    <app-no-content-stub class="w-full" imageSrc="assets/placeholders/empty-boards.svg" [size]="124">
      <p class="text-base font-medium text-gray-900 text-center">No board selected</p>
      <app-button2
        class="[&>button]:bg-offwhite"
        appearance="secondary"
        size="m"
        [gap]="4"
        [disabled]="busy()"
        [attr.aria-busy]="busy()"
        data-testid="board-empty-state-create"
        (click)="create()"
      >
        <app-icon name="sapphire-board-view" />
        {{ busy() ? 'Opening board…' : madeId() ? 'Open the board' : 'Create a new board' }}
      </app-button2>
      <div class="text-sm text-center" aria-live="polite">
        @if (error()) {
          <p role="alert" class="text-error">{{ error() }}</p>
        }
      </div>
    </app-no-content-stub>
  
